exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-container-parent {\n  background: #e5e5e5;\n  background-size: cover !important;\n  border: 1px dashed #a7a7a7;\n  margin: 15px auto 0px auto;\n  overflow: hidden; }\n\n.widget-container-parent::after {\n  content: \"\";\n  background: url(\"\");\n  opacity: 0.5;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n  z-index: -1; }\n\n.custom-range-slider-border {\n  border: 1px dashed #a7a7a7;\n  border-top: none;\n  margin: 0 auto;\n  padding: 0px 5px 0px 5px; }\n\n:host /deep/ .irs-bar-edge {\n  width: 2px;\n  background-position: 0 -90px; }\n\n:host /deep/ .irs-slider {\n  width: 3px;\n  background-position: -7px -120px; }\n\n:host /deep/ .irs-line:hover {\n  cursor: pointer; }\n\n:host /deep/ .irs-bar:hover {\n  cursor: pointer; }\n\n:host /deep/ .irs-slider:hover {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/campaign-preview/campaign-preview.component.scss
// module id = 1456
// module chunks = 18